var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","dark":"","color":"accent","href":_vm.href,"target":"_blank","small":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }